/**
 *
 * Ask
 *
 */

import { QaTitleModelMixin } from './model';

import QaTitle from '@/components/QA/Title.vue';

export const QaTitleMixin = {
  name: 'QaTitleMixin',

  mixins: [QaTitleModelMixin],

  components: {
    'qa-title': QaTitle,
  },

  data: () => {
    return {};
  },

  computed: {
    c_isQaTitleReady() {
      return !this.c_isQaTitleBlank && !this.c_isQaTitleToolong;
    },
  },

  methods: {
    clearQaTitle() {
      this.qaTitle = '';
    },
  },
};

export default QaTitleMixin;
